export default {
  init() {
    // JavaScript to be fired on all pages
    $(window).on('load scroll', function () {
      const top = $(window).scrollTop();
      const header = $('header.banner');
      const primNav = $('#primaryNav');

      if (top > 100) {
        header.addClass('background--white shadow-sm reduced scrolled');
        primNav.addClass('reduced');
      } else if (top < 80) {
        header.removeClass('background--white shadow-sm reduced scrolled');
        primNav.removeClass('reduced');
      }
    });

    $('a.navbar-toggler').click(function() {
      $('header.banner').addClass('background--white shadow-sm reduced');

      if (!$('header.banner').hasClass('scrolled') || $('header.banner').hasClass('reduced')) {
        $('.nav-link').removeClass('background--white shadow-sm reduced navToggled');
      }
    });

    function isInSection(section, offset) {
      if (!section) {
        return false;
      }

      const sectionOffset = section.offset();
      if (sectionOffset) {
        const sectionOffsetTop = sectionOffset.top;
        const sectionHeight = section.height();
        return (
          offset >= sectionOffsetTop &&
          offset <= sectionOffsetTop + sectionHeight
        );
      }
      return false;
    }

    // Sticky Tabs
    $(window).on('load scroll', function () {
      $('.sibebar-menu').each(function () {
        const headerHeight = $('#masthead').height();
        const tabOffsetTop = $(this).offset().top;
        const windowOffset = $(window).scrollTop();
        const totalOffset = windowOffset + headerHeight;
        const isActive = tabOffsetTop <= totalOffset;

        const tabsHeight = $(this).height();

        $(this).css('top', headerHeight);
        if (isActive) {
          $(this).addClass('active');

          const tabLinks = $(this).find('.nav-link');
          tabLinks.removeClass('active');

          tabLinks.each(function () {
            const href = $(this).attr('href');

            const section = $(href);

            if (isInSection(section, totalOffset + tabsHeight)) {
              $(this).addClass('active');
              $(this).removeClass('visited');
              $(this).parent('li').prevAll().find('a').addClass('visited');
            }
          });
        } else {
          $(this).removeClass('active');
          $(this).find('.tab-link').removeClass('active');
        }
      });
    });

    /* Gallery Images */
    $('.wp-block-image a.single-img-popup').magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      closeBtnInside: false,
      fixedContentPos: true,
      mainClass: 'mfp-no-margins mfp-with-zoom',
      image: {
        verticalFit: true,
      },
      zoom: {
        enabled: true,
        duration: 300,
      },
    });

    $('.wp-block-gallery').each(function () {
      $(this).magnificPopup({
        delegate: 'a',
        type: 'image',
        closeOnContentClick: true,
        closeBtnInside: false,
        fixedContentPos: true,
        mainClass: 'mfp-no-margins mfp-with-zoom',
        image: {
          verticalFit: true,
        },
        zoom: {
          enabled: true,
          duration: 300,
        },
        gallery: {
          enabled: true,
          navigateByImgClick: true,
        },
      });
    });

    $('.video-popup').magnificPopup({
      disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false,
    });

    if ($('.wp-block-acf-products').length) {
      // Set tab nav
      var tabLink = window.location.hash;
      $('.nav-tabs .nav-link').removeClass('active');
      $('.nav-tabs .nav-link').attr('aria-selected', 'false');
      $(tabLink).addClass('active');
      $(tabLink).attr('aria-selected', 'true');

      // Set tab link
      var tabPane = tabLink.replace('-tab', '');
      $('.tab-pane').removeClass('active show');
      $(tabPane).addClass('active show');
    }

    $('.open-search-wrap').on('click', function () {
      $('.search-modal').removeClass('out');
      $('.search-modal').addClass('open');
      $(document.body).addClass('modal-open');
    });

    $('.search-close').on('click', function () {
      $('.search-modal').addClass('out');
      $('.search-modal').removeClass('open');
      $(document.body).removeClass('modal-open');
    });

    var delayInMilliseconds = 0.5; //1 second
    setTimeout(function () {
      $(document.body).removeClass('preload');
    }, delayInMilliseconds);

    /**
     * Tray JS
     */
    $('.instrument-popover').popover({
      trigger: 'toggleEnabled',
    });

    $('.instrument').hover(function () {
      var mainTray = $(this).parent().find('#main-tray');
      $(mainTray).addClass('opacify');
      $(this).addClass('active');
    }, function () {
      var mainTray = $(this).parent().find('#main-tray');
      $(mainTray).removeClass('opacify');
      $(this).removeClass('active');
    });

    function daysInMonth(month, year) {
      let d = new Date(year, month + 1, 0);
      return d.getDate();
    }

    function positionEvents(category) {
      $('.day-content').html('');
      $('#calendar .events .event').each(function () {
        const date = $(this).data('date');
        const categories = $(this).data('categories');
        const dateContainer = $('#' + date);

        if (category && !categories.includes(category)) {
          return;
        }

        const duration = $(this).data('duration')
          ? $(this).data('duration')
          : 0;

        if ($('#' + date).length) {

          let element = dateContainer;

          for (let i = 0; i <= duration; i++) {
            let position = '';
            if (i === 0) {
              position = 'first';
            } else if (i === duration) {
              position = 'last';
            }
            element
              .find('.day-content')
              .append(
                `<div class="event ${position}">${$(
                  this
                ).html()}</div>`
              );
            element = element.next();
          }
        }
      });
    }

    // Calendar
    function getSelectedCategory(element = null) {
      if (!element) {
        element = '.events-block .filter .nav-link.active';
      }
      const selectedCategory = $(element);
      if (selectedCategory) {
        const href = selectedCategory.attr('href');
        const subItem = $(href).find('.category-link.active');
        if (subItem.length) {
          return subItem.data('category');
        }
        return selectedCategory.data('category');
      }
      return null;
    }

    function loadCalendarDays() {

      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      const calendar = $('#calendar');
      const currentMonth = calendar.data('month');
      const currentYear = calendar.data('year');

      calendar.find('.current-date .month').text(months[currentMonth]);
      calendar.find('.current-date .year').text(currentYear);

      $('#calendarDays').html('');

      const tmpDate = new Date(currentYear, currentMonth, 0);
      const num = daysInMonth(currentMonth, currentYear);
      const dayofweek = tmpDate.getDay(); // find where to start calendar day of week

      const lastMonthCount = new Date(currentYear, currentMonth, 0).getDate();
      let count = 0;

      // create day prefixes
      if (dayofweek < 6) {
        for (var i = 0; i <= dayofweek; i++) {
          count++;
          const number = lastMonthCount - (dayofweek - i);
          $('#calendarDays').append(`
            <div id=${number + '-' + Number(currentMonth) + '-' + currentYear
            } class='day blank'>
              <span class='day-title'>${number}</span>
              <div class='day-content'></div>
            </div>
          `);
        }
      }

      // render the rest of the days
      for (var day = 0; day < num; day++) {
        count++;
        $('#calendarDays').append(`
          <div id=${day + 1 + '-' + Number(currentMonth + 1) + '-' + currentYear
          } class='day'>
            <span class='day-title'>${day + 1}</span>
            <div class='day-content'></div>
          </div>
          `);
      }

      let nextMonthDay = 1;
      while (count % 7) {
        count++;

        $('#calendarDays').append(`
          <div id=${nextMonthDay + '-' + Number(currentMonth + 2) + '-' + currentYear
          } class='day blank'>
            <span class='day-title'>${nextMonthDay}</span>
            <div class='day-content'></div>
          </div>
          `);
        nextMonthDay++;
      }

      const selectedCategory = getSelectedCategory();
      positionEvents(selectedCategory);
    }

    function updateCalendar(monthChange) {
      const calendar = $('#calendar');
      let month = calendar.data('month') + monthChange;
      let year = calendar.data('year');
      if (month < 0) {
        month += 12;
        year -= 1;
      } else if (month > 11) {
        month -= 12;
        year += 1;
      }
      calendar.data('month', month);
      calendar.data('year', year);
      loadCalendarDays();
    }

    $('.calendar-dates .arrow-left').click(function (e) {
      e.preventDefault();
      updateCalendar(-1);
    });

    $('.calendar-dates .arrow-right').click(function (e) {
      e.preventDefault();
      updateCalendar(1);
    });

    $('.calendar-views .list-view').click(function (e) {
      e.preventDefault();
      $('.event-view.calendar-view').hide();
      $('.calendar-views .calendar-view').removeClass('active');
      $('.event-view.list-view').show();
      $('.calendar-views .list-view').addClass('active');
    });

    $('.calendar-views .calendar-view').click(function (e) {
      e.preventDefault();
      $('.event-view.list-view').hide();
      $('.calendar-views .list-view').removeClass('active');
      $('.event-view.calendar-view').show();
      $('.calendar-views .calendar-view').addClass('active');
    });

    function updateListEvents(category) {
      $('.events-block .event-view.list-view .event-date').each(function () {
        const categories = $(this).data('categories');

        if (category && !categories.includes(category)) {
          $(this).fadeOut();
        } else {
          $(this).fadeIn();
        }
      });
    }

    $(
      '.events-block .filter .category-link, .events-block .sub-filter .category-link'
    ).click(function () {
      const selectedCategory = getSelectedCategory(this);
      positionEvents(selectedCategory);
      updateListEvents(selectedCategory);
    });

      // Set up calendar
      loadCalendarDays();
      const selectedCategory = getSelectedCategory();
      updateListEvents(selectedCategory);
      $('.event-view.list-view').show();
      $('.calendar-views .list-view').addClass('active');
    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    $(window).on('load', function () {
      const headerHeight = $('#masthead').height();
      const sliderBlock = $('.slider-block .slick-slide');
      const iconOverlay = $('.slider-block .icon-overlay');

      sliderBlock.css('padding-top', headerHeight);
      iconOverlay.css('padding-top', headerHeight);
    });

    jQuery('.slider-block').slick({
      dots: true,
      infinite: true,
      arrows: false,
      fade: true,
      speed: 600,
      slidesToShow: 1,
      autoplaySpeed: 6000,
      autoplay: true,
      adaptiveHeight: true,
    });

    // Init products slider
    jQuery('.products-slider-container').slick({
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.prev'),
      nextArrow: $('.next'),
      lazyLoad: "ondemand",
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1650,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js